import PropTypes from 'prop-types'
import React from 'react'
import { Col, Input, Label, Row } from 'reactstrap'

export const StatusOptions = () => <>
  <option value=''>ALL</option>
  <option value='assigned'>ASSIGNED</option>
  <option value='replaced'>REPLACED</option>
</>

export const CountOptions = () => <>
  <option value=''>ALL</option>
  {['0', '1', '2', '3', '4', '5'].map((value) => <option key={value} value={`eq:${value}`}>{value}</option>)}
  <option value='lt:2'>&lt; 2</option>
  <option value='lte:2'>&le; 2</option>
  <option value='gt:0'>&gt; 0</option>
  <option value='gt:2'>&gt; 2</option>
  <option value='gte:2'>&ge; 2</option>
  <option value='gt:5'>&gt; 5</option>
</>

const ReportFilters = ({ filters, onChange, assignees }) => {
  const update = (key) => (event) => {
    const value = event.target.value
    onChange((current) => ({ ...current, [key]: value }))
  }
  return <Row form>
    <Col md='4' className='mb-2'>
      <Label for='progress-sa'>SA</Label>
      <Input id='progress-sa' aria-label='Progress SA' type='select' value={filters.assignee_id} onChange={update('assignee_id')}>
        <option value=''>ALL</option>
        {assignees.map((sa) => <option key={sa.id} value={sa.id}>{sa.name} — {sa.internal_category || '-'}</option>)}
      </Input>
    </Col>
    <Col md='4' className='mb-2'>
      <Label for='progress-category'>Category</Label>
      <Input id='progress-category' type='select' value={filters.internal_category} onChange={update('internal_category')}>
        <option value=''>Semua kategori</option><option value='C'>C</option><option value='H'>H</option>
      </Input>
    </Col>
    <Col md='4' className='mb-2'>
      <Label for='progress-status'>Status</Label>
      <Input id='progress-status' aria-label='Progress status' type='select' value={filters.status} onChange={update('status')}><StatusOptions /></Input>
    </Col>
    <Col md='4' className='mb-2'>
      <Label for='progress-arrival-from'>New Arrival dari (WIB)</Label>
      <Input id='progress-arrival-from' aria-label='Progress arrival from WIB' type='datetime-local' value={filters.arrival_from} onChange={update('arrival_from')} />
    </Col>
    <Col md='4' className='mb-2'>
      <Label for='progress-arrival-to'>New Arrival sampai (WIB)</Label>
      <Input id='progress-arrival-to' aria-label='Progress arrival to WIB' type='datetime-local' value={filters.arrival_to} onChange={update('arrival_to')} />
    </Col>
  </Row>
}
ReportFilters.propTypes = {
  filters: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  assignees: PropTypes.array.isRequired
}
export default ReportFilters
